import { useCallback } from 'react';
import { useLoading } from '../../../context';

export const useSubmitLogin = () => {
  const { showLoading, hideLoading } = useLoading();

  const submitLogin = useCallback(
    async (formData) => {
      try {
        showLoading();
        const response = await fetch('/api/user/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password,
          }),
        });
        if (response.ok) {
          const data = await response.json();
          return data.data;
        } else {
          const errorResponse = await response.json();
          throw errorResponse;
        }
      } catch (err) {
        throw err;
      } finally {
        hideLoading();
      }
    },
    [hideLoading, showLoading]
  );

  return { submitLogin };
};
